import styled from 'styled-components';
import { colors, toRgba } from '@/styles';
import Link from 'next/link';

export const ViewEvaluation = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  flex: 1;

  & > * {
    box-shadow: 2px 2px 5px 0px ${toRgba(colors.primary.black, 0.2)};
    /* overflow: hidden; */
    &:first-child {
      border-radius: 5px;
    }
  }

  .dataframe-client-wrapper {
    background-color: ${colors.secondary.lightGray1};
  }
`;
